<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入套餐名称查询" style="width: 200px" v-model="title"></el-input>
      <el-select v-model="category" placeholder="请选择套餐类别" style="width: 150px; margin-left: 10px" clearable>
        <el-option label="婚纱摄影" value="wedding"></el-option>
        <el-option label="儿童写真" value="children"></el-option>
        <el-option label="个人写真" value="personal"></el-option>
        <el-option label="情侣写真" value="couple"></el-option>
        <el-option label="全家福" value="family"></el-option>
      </el-select>
      <el-button type="info" plain style="margin-left: 10px" @click="load(1)">查询</el-button>
      <el-button type="warning" plain style="margin-left: 10px" @click="reset">重置</el-button>
    </div>

    <div class="operation">
      <el-button type="primary" plain @click="handleAdd">新增</el-button>
      <el-button type="danger" plain @click="delBatch">批量删除</el-button>
    </div>

    <div class="table">
      <el-table :data="tableData" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="id" label="序号" width="80" align="center" sortable></el-table-column>
        <el-table-column prop="title" label="套餐名称"></el-table-column>
        <el-table-column prop="category" label="套餐类别" width="120">
          <template v-slot="scope">
            <el-tag>{{ getCategoryName(scope.row.category) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="套餐图片" width="180">
          <template v-slot="scope">
            <el-image v-if="scope.row.image" style="width: 100px; height: 60px" :src="scope.row.image" fit="cover" 
                     :preview-src-list="[scope.row.image]"></el-image>
            <span v-else>暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="120">
          <template v-slot="scope">
            <div>
              <span class="price">¥{{ scope.row.price }}</span>
              <span v-if="scope.row.originalPrice" class="original-price">¥{{ scope.row.originalPrice }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="简介" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>

        <el-table-column label="操作" width="180" align="center">
          <template v-slot="scope">
            <el-button plain type="primary" @click="handleEdit(scope.row)" size="mini">编辑</el-button>
            <el-button plain type="danger" size="mini" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20]"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="套餐信息" :visible.sync="formVisible" width="40%" :close-on-click-modal="false" destroy-on-close>
      <el-form label-width="100px" style="padding-right: 50px" :model="form" :rules="rules" ref="formRef">
        <el-form-item prop="title" label="套餐名称">
          <el-input v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="category" label="套餐类别">
          <el-select v-model="form.category" placeholder="请选择套餐类别" style="width: 100%">
            <el-option label="婚纱摄影" value="wedding"></el-option>
            <el-option label="儿童写真" value="children"></el-option>
            <el-option label="个人写真" value="personal"></el-option>
            <el-option label="情侣写真" value="couple"></el-option>
            <el-option label="全家福" value="family"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="price" label="价格">
          <el-input-number v-model="form.price" :precision="2" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item prop="originalPrice" label="原价">
          <el-input-number v-model="form.originalPrice" :precision="2" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item prop="image" label="套餐图片">
          <el-upload
              class="avatar-uploader"
              :action="$baseUrl + '/files/upload'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess">
            <img v-if="form.image" :src="form.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="description" label="简介">
          <el-input type="textarea" :rows="2" v-model="form.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="details" label="详细内容">
          <el-input type="textarea" :rows="5" v-model="form.details" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="sortOrder" label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" :max="1000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PricePackage",
  data() {
    return {
      tableData: [],  // 所有的数据
      pageNum: 1,   // 当前的页码
      pageSize: 10,  // 每页显示的个数
      total: 0,
      title: null,
      category: null,
      formVisible: false,
      form: {
        sortOrder: 0,
        price: 0,
        originalPrice: 0
      },
      categoryMap: {
        'wedding': '婚纱摄影',
        'children': '儿童写真',
        'personal': '个人写真',
        'couple': '情侣写真',
        'family': '全家福'
      },
      rules: {
        title: [
          {required: true, message: '请输入套餐名称', trigger: 'blur'},
        ],
        category: [
          {required: true, message: '请选择套餐类别', trigger: 'change'},
        ],
        price: [
          {required: true, message: '请输入价格', trigger: 'blur'},
        ],
        image: [
          {required: true, message: '请上传套餐图片', trigger: 'blur'},
        ],
        description: [
          {required: true, message: '请输入简介', trigger: 'blur'},
        ],
        sortOrder: [
          {required: true, message: '请输入排序', trigger: 'blur'},
        ]
      },
      ids: []
    }
  },
  created() {
    this.load(1)
  },
  methods: {
    getCategoryName(code) {
      return this.categoryMap[code] || code
    },
    handleAvatarSuccess(res) {
      if (res.code === '200') {
        this.form.image = res.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleAdd() {   // 新增数据
      this.form = {
        sortOrder: 0,
        price: 0,
        originalPrice: 0
      }  // 新增数据的时候设置默认值
      this.formVisible = true   // 打开弹窗
    },
    handleEdit(row) {   // 编辑数据
      this.form = JSON.parse(JSON.stringify(row))  // 给form对象赋值  注意要深拷贝数据
      this.formVisible = true   // 打开弹窗
    },
    save() {   // 保存按钮触发的逻辑  它会触发新增或者更新
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$request({
            url: this.form.id ? '/price/package/admin/' + this.form.id : '/price/package/admin',
            method: this.form.id ? 'PUT' : 'POST',
            data: this.form
          }).then(res => {
            if (res.code === '200') {  // 表示成功保存
              this.$message.success('保存成功')
              this.load(1)
              this.formVisible = false
            } else {
              this.$message.error(res.msg)  // 弹出错误的信息
            }
          })
        }
      })
    },
    del(id) {   // 单个删除
      this.$confirm('您确定删除吗？', '确认删除', {type: "warning"}).then(response => {
        this.$request.delete('/price/package/admin/' + id).then(res => {
          if (res.code === '200') {   // 表示操作成功
            this.$message.success('操作成功')
            this.load(1)
          } else {
            this.$message.error(res.msg)  // 弹出错误的信息
          }
        })
      }).catch(() => {
      })
    },
    handleSelectionChange(rows) {   // 当前选中的所有的行数据
      this.ids = rows.map(v => v.id)   //  [1,2]
    },
    delBatch() {   // 批量删除
      if (!this.ids.length) {
        this.$message.warning('请选择数据')
        return
      }
      this.$confirm('您确定批量删除这些数据吗？', '确认删除', {type: "warning"}).then(response => {
        this.$request.delete('/price/package/admin/batch', {data: this.ids}).then(res => {
          if (res.code === '200') {   // 表示操作成功
            this.$message.success('操作成功')
            this.load(1)
          } else {
            this.$message.error(res.msg)  // 弹出错误的信息
          }
        })
      }).catch(() => {
      })
    },
    load(pageNum) {  // 分页查询
      if (pageNum) this.pageNum = pageNum
      this.$request.get('/price/package/admin/list', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          title: this.title,
          category: this.category
        }
      }).then(res => {
        this.tableData = res.data?.list
        this.total = res.data?.total
      })
    },
    reset() {
      this.title = null
      this.category = null
      this.load(1)
    },
    handleCurrentChange(pageNum) {
      this.load(pageNum)
    },
  }
}
</script>

<style scoped>
.avatar-uploader {
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.price {
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}

.original-price {
  color: #909399;
  text-decoration: line-through;
  margin-left: 10px;
  font-size: 14px;
}
</style> 